import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;
  margin-bottom: 12px;
`;

export const OptionGroup = styled.div`
  margin-bottom: 14px;
`;

export const Label = styled.div`
  font-weight: 500;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.63);
  margin-bottom: 10px;
`;

export const ThumbnailList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const ThumbnailItem = styled.div<{
  $isActive: boolean;
  $isDisabled: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  padding: 4px;
  border-radius: 4px;
  border: 2px solid
    ${({ $isActive }) => ($isActive ? '#009ace' : 'transparent')};
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.4 : 1)};
  transition: all 0.1s linear;

  &:hover {
    border-color: ${({ $isActive, $isDisabled }) =>
      $isDisabled
        ? 'transparent'
        : $isActive
          ? '#009ace'
          : 'rgba(0, 0, 0, 0.23)'};
  }
`;

export const ThumbnailImage = styled.img<{ $isActive: boolean }>`
  width: 60px;
  height: 60px;
  aspect-ratio: 1 / 1;
  object-fit: contain;
  border-radius: 4px;
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.85)};
  transition: opacity 0.1s linear;

  &:hover {
    opacity: 1;
  }
`;

export const OptionLabel = styled.span`
  font-size: 0.75rem;
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
